import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import Dropdown from "../../../components/Dropdown";
import { createStatus } from "../../../reducers/talentMypage";

interface DesiredWorkingPlaceProps {
    onClose: () => void;
}

const DesiredWorkingPlace: React.FC<DesiredWorkingPlaceProps> = ({ onClose }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const talentMypage = useSelector((state: any) => state.talentMypage)
    const { isLoading, cityOptions } = useSelector((state: any) => state.talentMypage)
    const [isEditing, setIsEditing] = useState(false)
    const [selectedCity, setSelectedCity] = useState<any>(null);
    const [selectedCity2, setSelectedCity2] = useState<any>(null);
    const [selectedCity3, setSelectedCity3] = useState<any>(null);

    useEffect(() => {
        if(talentMypage?.talent && cityOptions) {
            const city1 = cityOptions.find((item:any) => item?.id === talentMypage?.talent?.preferred_city_1_id);
            const city2 = cityOptions.find((item:any) => item?.id === talentMypage?.talent?.preferred_city_2_id);
            const city3 = cityOptions.find((item:any) => item?.id === talentMypage?.talent?.preferred_city_3_id);
            setSelectedCity(city1 || null);
            setSelectedCity2(city2 || null);
            setSelectedCity3(city3 || null);
        }
    }, [talentMypage, cityOptions])

    const saveChangeCity = () => {
        if(selectedCity?.id == talentMypage?.talent?.preferred_city_1_id &&
            selectedCity2?.id == talentMypage?.talent?.preferred_city_2_id &&
            selectedCity3?.id == talentMypage?.talent?.preferred_city_3_id) {
            return
        }
        dispatch(createStatus({
            requestBody: { 
                change_job_status_id: talentMypage?.talent?.change_job_status?.id || null, 
                work_parttime_status_id: talentMypage?.talent?.work_part_time_status?.id || null, 
                profession_1_id: talentMypage?.talent?.profession_1_id || null,
                profession_2_id: talentMypage?.talent?.profession_2_id || null,
                profession_3_id: talentMypage?.talent?.profession_3_id || null,
                industry_1_id: talentMypage?.talent?.industry_1_id || null,
                industry_2_id: talentMypage?.talent?.industry_2_id || null,
                industry_3_id: talentMypage?.talent?.industry_3_id || null,
                working_style_1_id: talentMypage.talent?.working_style_1_id || null,
                working_style_2_id: talentMypage.talent?.working_style_2_id || null,
                working_style_3_id: talentMypage.talent?.working_style_3_id || null,
                preferred_city_1_id: selectedCity?.id || null,
                preferred_city_2_id: selectedCity2?.id || null,
                preferred_city_3_id: selectedCity3?.id || null
            },
          }),
        );
        setIsEditing(false)
        onClose();
      };

    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
            <div className="flex items-center justify-between gap-2 px-4 mb-1">
                <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">希望する勤務地</h2>
                <CustomIconButton onClick={onClose} customStyle="shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
                <form className="mt-6 w-full flex flex-col">

                    {/* {isEditing && ( */}
                    <label className="alu-text-base-2 text-sm font-bold mb-2">第一希望</label>
                    <Dropdown
                        options={cityOptions}
                        value={selectedCity}
                        onChange={(value: any) => {setSelectedCity(value); setIsEditing(true)}}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">第二希望</label>
                    <Dropdown
                        options={cityOptions}
                        value={selectedCity2}
                        onChange={(value: any) => {setSelectedCity2(value); setIsEditing(true)}}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-4"
                        optionsFixedWidth={true}
                        disabled={!selectedCity}
                    />
                    <label className="alu-text-base-2 text-sm font-bold mb-2">第三希望</label>
                    <Dropdown
                        options={cityOptions}
                        value={selectedCity3}
                        onChange={(value: any) => {setSelectedCity3(value); setIsEditing(true)}}
                        placeholder="選択してください"
                        inputWidth="full"
                        customStyle="mb-10"
                        optionsFixedWidth={true}
                        disabled={!selectedCity2}
                    />
                    
                    <div className="flex items-center justify-between gap-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            type="button"
                            onClick={() => saveChangeCity()}
                            disabled={isLoading || !isEditing}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DesiredWorkingPlace;